"use strict";

import Swiper from "swiper";
// import {Navigation, Pagination} from "swiper";

const {sendDoubleEvents} = require('./analytics/analytics');
const {getParameterByName, checkAuth} = require('./common');

const UpgradeController = require('./upgrade/controllers/upgradeController');

// Swiper.use([Navigation, Pagination]);


const common = {
	init: function () {
		this.params = new URL(window.location.href).searchParams;
		this.software = this.params.get("software");
		this.url = this.params.get("url");
		this.upgrade = location.pathname.includes('upgrade');
		this.tariff = this.params.get("t") ? atob(this.params.get("t")) : null;
		this.period = this.params.get("p") ? atob(this.params.get("p")): null;
		this.licenseId = this.params.get("l") ? atob(this.params.get("l")): null;
		this.hash = this.params.get("h") ? atob(this.params.get("h")): null;
		this.tariffsBlock = document.getElementById('js_tariffs');
		if (!this.tariffsBlock) {
			return;
		}
		this.extensionMode = location.pathname.includes('extension');

		this.checkLink = function (e) {
			return e.target.tagName === 'A' && e.target.href.includes('/checkout');
		}

		pricing.init();

		if (this.extensionMode) {
			extension.init();
			this.upgrade && upgrade.init();
		}
	}
}
const defineCn = function () {
	if (typeof window !== undefined) return (window.location.href.indexOf("cn") > -1) ? "/cn/checkout/?offerId=" : '/checkout/?offerId='
}
const pricing = {
	init: function () {
		this.tariffsBlock = common.tariffsBlock;
		this.fixBlockWrapper = document.querySelector('#js_tariffs .tariffs__header-wrapper');
		this.fixBlock = document.querySelector('#js_tariffs .tariffs__header-wrapper .tariffs__header');
		this.table = document.querySelector('#js_tariffs .tariffs-table');
		this.buttons = this.tariffsBlock.getElementsByClassName('tariffs-list-offer__btn');
		this.fixClassName = !document.location.pathname.includes('iframe') ? "tariffs__header_fix" : "tariffs__header_iframeFix";
		this.modalPricing = document.querySelector('#js-modalPricing .webinarModal-container');
		this.extension = window.location.pathname.includes('extension');
		this.software = common.software;
		this.checkAuth = checkAuth();
		this.mobileWidth = this.software === "QUICK_VIEW_EXT" ? 746 : 768;
		this.isLessXL = () => this.windowWidth < 1200;
		this.isMobile = () => this.windowWidth < this.mobileWidth;

		if (this.tariffsBlock) {
			this.windowWidth = 0;

			if (!this.modalPricing) {
				this.changeWindowHandler();
			} else {
				this.windowWidthHandle();
			}
			this.setHref('yearly');
			this.changeByAuth();
			this.tariffsBlock.classList.add(`state-${this.extension ? '1' : '0'}`);

			document.getElementById('js_selectMonthlyPlan').addEventListener('click', this.selectMonthlyPlan.bind(pricing));
			document.getElementById('js_selectYearlyPlan').addEventListener('click', this.selectYearlyPlan.bind(pricing));
			document.getElementById('js_selectMonthlyPlanScroll').addEventListener('click', this.selectMonthlyPlan.bind(pricing));
			document.getElementById('js_selectYearlyPlanScroll').addEventListener('click', this.selectYearlyPlan.bind(pricing));

			if (!this.modalPricing) {
				window.addEventListener('scroll', this.changeWindowHandler.bind(pricing));
				window.addEventListener('resize', this.changeWindowHandler.bind(pricing));
			} else {
				this.modalPricing.addEventListener("scroll", this.scrollModal.bind(pricing));
			}

			if (common.upgrade && common.period === "monthly") {
				common.upgrade && this.tariffsBlock.classList.add('monthly_upgrade');
			}

			this.renderSwiper();
			this.handleEvents();
		}
	},
	handleEvents: function () {
		this.tariffsBlock.addEventListener('click', e => {
			if (e.target.tagName === 'A') {
				sendDoubleEvents(e,common.upgrade ? "Upgrade" : "BuyNow", "PricingLP", e.target.href.split('&url=')[0], false, !common.upgrade);
			}
		})
	},
	setHref: function (period) {
		Array.prototype.slice.call(this.buttons).forEach(item => {
			item.href = item.dataset.link || `${defineCn()}` + item.dataset[period === 'monthly' ? 'monthlyLink' : 'yearlyLink'];
		})
	},
	changeByAuth: function () {
		if (this.checkAuth) {
			Array.prototype.slice.call(this.buttons).forEach(item => {
				if (item.dataset.authlink) {
					item.href = item.dataset.authlink;
				}
			});
		}
	},
	selectMonthlyPlan: function () {
		this.tariffsBlock.classList.remove('yearly');
		this.tariffsBlock.classList.add('monthly');
		this.setHref('monthly');
		common.extensionMode && extension.handleAnalytics();
	},
	selectYearlyPlan: function () {
		this.tariffsBlock.classList.remove('monthly');
		this.tariffsBlock.classList.add('yearly');
		this.setHref('yearly');
		common.extensionMode && extension.handleAnalytics();
	},
	windowWidthHandle: function () {
		this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	},
	handleStickyHeaderTable: function () {
		let whenEnableScrollValue = this.isLessXL() ? 64 : 81;
		if (this.extension) {
			whenEnableScrollValue = 5;
		}
		const isHeaderOnBottom = (this.tariffsBlock.getBoundingClientRect().height + this.tariffsBlock.getBoundingClientRect().top) <=
			this.fixBlockWrapper.getBoundingClientRect().height + 120;
		if (this.fixBlockWrapper.getBoundingClientRect().top < whenEnableScrollValue) {
			this.fixBlockWrapper.classList.add('tariffs__header-wrapper_fixed');
			this.table.classList.add('tariffs-table_scroll');
			if (isHeaderOnBottom) {
				this.fixBlock.classList.remove(this.fixClassName);
			} else {
				this.fixBlock.classList.add(this.fixClassName);
			}
		} else {
			this.fixBlockWrapper.classList.remove('tariffs__header-wrapper_fixed');
			this.fixBlock.classList.remove(this.fixClassName);
			this.table.classList.remove('tariffs-table_scroll');
		}
	},
	scrollModal: function () {
		this.windowWidthHandle();
		const whenEnableScrollValue = 18;
		if (this.fixBlockWrapper.getBoundingClientRect().top < whenEnableScrollValue) {
			this.fixBlockWrapper.classList.add('tariffs__header-wrapper_fixed');
			this.table.classList.add('tariffs-table_scroll');
			this.fixBlock.classList.add(this.fixClassName);
			this.fixBlock.classList.add('tariffs__header_modalFix');
		} else {
			this.fixBlockWrapper.classList.remove('tariffs__header-wrapper_fixed');
			this.fixBlock.classList.remove(this.fixClassName);
			this.table.classList.remove('tariffs-table_scroll');
		}
	},
	changeWindowHandler: function () {
		this.windowWidthHandle();
		this.handleStickyHeaderTable();
	},
	renderSwiper: function () {
		const swiper = new Swiper('.swiper-container-tarrifs', {
			observer: true,
			observeParents: true,
			slidesPerView: 'auto',
			spaceBetween: 4,
			centeredSlides: true,
			loop: false,
			pagination: {
				el: '#js_swiper-pagination',
				clickable: true,
			},
		})
		swiper.on('slideChange', ({previousIndex, activeIndex}) => {
			this.tariffsBlock.classList.remove(`state-${this.extension ? previousIndex + 1 : previousIndex}`);
			this.tariffsBlock.classList.add(`state-${this.extension ? activeIndex + 1 : activeIndex}`);
		})
		if (window.innerWidth < this.mobileWidth && this.extension) {
			swiper.removeSlide(0);
		}
	}
}

const extension = {
	init: function () {
		this.software = common.software;
		this.handleAnalytics(true);
		this.handleSoftwareModes();
	},
	handleSoftwareModes: function () {
		if (this.software === "QUICK_VIEW_EXT") {
			document.getElementById('js_tariffs').classList.add('tariffs_qw');
		}
	},
	handleAnalytics: function (status) {
		const updateUrl = (element) => {
			if (element.href.includes('/checkout')) {
				element.href += `&software=${this.software}`;
				if (common.url) {
					element.href += `&url=${encodeURIComponent(common.url)}`;
				}
			}
		}
		const addTarget = (element) => {
			element.setAttribute("target", "_blank");
		}
		const apply = () => {
			Array.prototype.slice.call(document.getElementsByTagName('a')).forEach(a => {
				updateUrl(a);
				status && addTarget(a);
			});
		}
		this.software ? apply() : console.error('Software undefined, please check query string.');
	}
}

const upgrade = {
	init: function () {
		this.tariff = common.tariff;
		this.period = common.period;
		this.hash = common.hash;
		this.licenseId = common.licenseId;
		this.url = common.url;
		this.checkParams();
		this.changeButtonTitles();
	},
	lightDisplay: function () {
		document.querySelectorAll('.upgrade__light_blur').forEach(e => e.style.opacity = '0.6');
		document.querySelectorAll('.upgrade__light_hidden').forEach(e => e.style.display = 'flex');
		document.querySelectorAll('.upgrade__light_hide').forEach(e => e.style.display = 'none');
	},
	checkPlan: function () {
		if (this.tariff === 'light') {
			this.lightDisplay();
			if (this.period !== 'monthly') {
				Array.prototype.slice.call(document.querySelectorAll('.tariffs-tabs')).forEach(e => {
					e.style.display = 'none';
				});
				document.getElementById('js_selectYearlyPlan').click();
			}
		}
	},
	blockAccess: function () {
		document.querySelector('body').innerHTML = '<h1>Required parameters are missing or current tariff is not supported</h1>';
	},
	displayBlock: function (status) {
		document.getElementById('js_upgrade-block').style.display = status ? 'flex' : 'none';
		document.querySelector('body').style.overflow = status ? 'hidden': '';
	},
	displayError: function (status) {
		document.getElementById('js_upgrade-error').style.display = status ? 'block' : 'none';
	},
	displayLoader: function (status) {
		document.getElementById('js_upgrade-loader').style.display = status ? 'flex' : 'none';
	},
	listenErrorClose: function () {
		document.getElementById('js_upgrade-error').addEventListener('click', event => {
			const checkClassName = (target) => {
				return target.classList.contains('request-error__close');
			}

		  if (checkClassName(event.target) || checkClassName(event.target.parentNode)) {
		  	this.displayError(false);
		  	this.displayBlock(false);
			}
		});
	},
	createUpgrade: function () {
		this.listenErrorClose();
		this.user = new UpgradeController(this.code, this.tariff, this.period,  this.licenseId, this.hash, common.software);
		this.user.request(this.displayLoader, this.displayError, this.displayBlock, this.url || null);
	},
	handleCollect: function () {
		common.tariffsBlock.addEventListener('click', (e) => {
			if (common.checkLink(e)) {
				e.preventDefault();
				this.code = getParameterByName("offerId", e.target.href);
				this.createUpgrade();
			}
		});
	},
	checkParams: function () {
		if (!this.tariff || !this.period || !this.licenseId || !this.hash) {
			this.blockAccess();
		} else {
			this.checkPlan();
			this.handleCollect();
		}
	},
	changeButtonTitles: function () {
		Array.prototype.slice.call(document.querySelectorAll('[data-upgrade-title]')).forEach(b => {
			b.textContent = b.dataset.upgradeTitle;
			b.classList.add('tariffs-list-offer__btn_small');
		});
	}
}

common.init();